import React from "react";
import { Chart as ReactChart } from "react-chartjs-2";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    LineController,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Title,
    Filler,
} from "chart.js";
import { commonService } from "../../utils/commonService";

Chart.register(
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    LineController,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    Title,
    Filler
);


// Renders a single graph object returned by the RM Copilot structured-chat API.
function RMCopilotChart({ graph }) {
    if (!graph || !Array.isArray(graph.x_axis) || !Array.isArray(graph.series)) {
        return null;
    }

    const hasRightAxis = graph.series.some((s) => s?.axis === "right");

    const datasets = graph.series.map((serie, index) => {
        const color = commonService.CreateColor(serie?.name || `Series ${index + 1}`).BGColor //CHART_COLORS[index % CHART_COLORS.length];
        const serieType = serie?.type === "bar" ? "bar" : "line";

        return {
            type: serieType,
            label: serie?.name || `Series ${index + 1}`,
            data: Array.isArray(serie?.values) ? serie.values : [],
            yAxisID: serie?.axis === "right" && hasRightAxis ? "y1" : "y",
            backgroundColor: serieType === "bar" ? color : "transparent",
            borderColor: color,
            borderWidth: 2,
            pointRadius: serieType === "line" ? 3 : 0,
            tension: 0.3,
            order: serieType === "bar" ? 2 : 1,
        };
    });

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: {
                display: true,
                position: "bottom",
                labels: {
                    boxWidth: 10,
                    boxHeight: 10,
                    font: { size: 10 },
                },
            },
            title: {
                display: !!graph.title,
                text: graph.title || "",
                font: { size: 12 },
            },
            tooltip: {
                mode: "index",
                intersect: false,
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { font: { size: 9 }, maxRotation: 60, minRotation: 0 },
            },
            y: {
                type: "linear",
                position: "left",
                beginAtZero: true,
                title: {
                    display: !!graph.left_axis_label,
                    text: graph.left_axis_label || "",
                    font: { size: 10 },
                },
                ticks: { font: { size: 9 } },
            },
            ...(hasRightAxis
                ? {
                      y1: {
                          type: "linear",
                          position: "right",
                          beginAtZero: true,
                          grid: { drawOnChartArea: false },
                          title: {
                              display: !!graph.right_axis_label,
                              text: graph.right_axis_label || "",
                              font: { size: 10 },
                          },
                          ticks: { font: { size: 9 } },
                      },
                  }
                : {}),
        },
    };

    return (
        <div style={{ height: 260, width: "100%" }}>
            <ReactChart
                type={graph.type === "line" ? "line" : "bar"}
                data={{ labels: graph.x_axis, datasets }}
                options={options}
            />
        </div>
    );
}

export default RMCopilotChart;
